// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"4d936b9b6b107fbbd49a","883":"9010073eedc7401948f3"}[chunkId] + ".js";
};